import { render, staticRenderFns } from "./ConfirmPasswordForm.vue?vue&type=template&id=fd3fe1a8&scoped=true"
import script from "./ConfirmPasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./ConfirmPasswordForm.ts?vue&type=script&lang=ts&external"
import style0 from "./ConfirmPasswordForm.vue?vue&type=style&index=0&id=fd3fe1a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3fe1a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd3fe1a8')) {
      api.createRecord('fd3fe1a8', component.options)
    } else {
      api.reload('fd3fe1a8', component.options)
    }
    module.hot.accept("./ConfirmPasswordForm.vue?vue&type=template&id=fd3fe1a8&scoped=true", function () {
      api.rerender('fd3fe1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/components/ConfirmPasswordForm/ConfirmPasswordForm.vue"
export default component.exports